import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { CentrexSdaModel } from '../models/centrex-sda.model';
import { ApiService } from './api.service';
import { ServiceBase } from './service-base';
import { MvnoMetricsModel } from '../models/mvno-metrics.model';

@Injectable({
  providedIn: 'root',
})
export class NexusServices extends ServiceBase {
  constructor(private http: HttpClient, private apiService: ApiService) {
    super();
  }

  private createHeaders(additionalHeaders?: {
    [key: string]: string;
  }): HttpHeaders {
    const token = this.apiService.getAccessToken();
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    });

    if (additionalHeaders) {
      Object.keys(additionalHeaders).forEach((key) => {
        headers = headers.set(key, additionalHeaders[key]);
      });
    }

    return headers;
  }

  private handleError(error: any): Observable<never> {
    console.error('Erreur CentrexSdasService', error);
    return throwError(() => error);
  }

  getSdas(
    organizationId: string,
    platform: string
  ): Observable<CentrexSdaModel[]> {
    const url = `${this.apiUrl}/api/centrex/sdas`; // Appel au proxy Nexus
    const headers = this.createHeaders({
      'X-OrganizationId': organizationId,
      'X-CentrexPlatform': platform,
    });

    return this.http
      .get<CentrexSdaModel[]>(url, { headers })
      .pipe(catchError(this.handleError));
  }

  getCentrexNgSdas(organizationId: string): Observable<CentrexSdaModel[]> {
    return this.getSdas(organizationId, 'Centrex NG');
  }

  getEnreachSdas(organizationId: string): Observable<CentrexSdaModel[]> {
    return this.getSdas(organizationId, 'Centrex Enreach');
  }

  getSdaById(
    organizationId: string,
    platform: string,
    sdaId: string
  ): Observable<CentrexSdaModel> {
    const url = `${this.apiUrl}/api/centrex/sdas/${sdaId}`; // Appel au proxy Nexus
    const headers = this.createHeaders({
      'X-OrganizationId': organizationId,
      'X-CentrexPlatform': platform,
    });

    return this.http
      .get<CentrexSdaModel>(url, { headers })
      .pipe(catchError(this.handleError));
  }

  // MVNO METRICS
  getMvnoMetrics(organizationId: string): Observable<MvnoMetricsModel> {
    const url = `${this.apiUrl}/api/mvno/metrics`; // via proxy .NET

    const headers = this.createHeaders({
      'X-OrganizationId': organizationId,
    });

    return this.http.get<any>(url, { headers }).pipe(
      map((response) => {
        if (Array.isArray(response)) {
          return { nbLines: response.length };
        }
        return { nbLines: 0 };
      }),
      catchError((error) => {
        console.error('Erreur MVNO', error);
        return of({ nbLines: 0 }); //retourne un objet correct MvnoMetricsModel
      })
    );
  }
}
